/*
 * Copyright © 2024. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, {ReactNode} from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/system";

type ButtonLoadingProps = {
  isLoading?: boolean;
  children?: ReactNode;
  disabled?: boolean;
  loadingText?: string;
} & ButtonProps<React.ElementType>;

const ButtonLoading = ({ isLoading = false, children, disabled = false, loadingText = "", ...rest }: ButtonLoadingProps) => {
  const theme = useTheme();

  return (
    <Button disabled={disabled || isLoading} {...rest}>
      {isLoading ? (
        <>
          <CircularProgress size={`calc(${theme.typography.button.fontSize} * ${theme.typography.button.lineHeight})`} />
          {loadingText && <Typography sx={{ paddingLeft: "10px" }}>{loadingText}</Typography>}
        </>
      ) : (
        children
      )}
    </Button>
  );
};

export default ButtonLoading;
